import { FC } from 'react';
import { ActiveAuthorizePaymentPage, Tabs } from 'common/constants';
import { useClient } from 'components/ClientProvider';
import { SkeletonHeader } from 'components/SkeletonLoader/SkeletonHeader';
import { StoreSelect } from 'components/StoreSelect';
import { AuthorizePaymentPage } from 'pages/AuthorizePaymentPage/AuthorizePaymentPage';
import { ReviewChecksPage } from 'pages/AuthorizePaymentPage/ReviewChecksPage';
import { LandingPageTable } from 'pages/HighVolumeLandingPage/LandingPageTable';
import { ReconciliationHeader } from 'pages/ReconciliationReportPage/ReconciliationHeader';
import { VendorPaymentResultPage } from 'pages/VendorPaymentResultPage';
import { VendorsReviewSelection } from 'pages/VendorsTablePage/components';
import { PrintChecksHeader } from 'pages/VendorsTablePage/components/PrintChecks/PrintChecksHeader';
import { PrintChecksPageHeader } from 'pages/VendorsTablePage/components/PrintChecks/PrintChecksPageHeader';
import { VendorsTablePage } from 'pages/VendorsTablePage/VendorsTablePage';
import { LandingPageHeader } from './components/LandingPageHeader/LandingPageHeader';
import { LandingPageContainer, StyledPageContentHeader } from './styled';

const AuthorizeScreenFlow: FC<{
  activeAuthorizePage: string;
  client: any;
  selectedTab: string;
  isFetchingPrintChecks: number;
  isLoading: boolean;
  interCompanyFlag: boolean | undefined;
  landingPageFlag: boolean | undefined;
  handleDeclineButtonClick: () => void;
  handleReviewButtonClick: () => void;
  handleReviewAndPrintButton: () => void;
  handlePrintCheckButtonClick: () => void;
  isDeclinePaymentLoading: boolean;
}> = ({
  activeAuthorizePage,
  client,
  selectedTab,
  isFetchingPrintChecks,
  isLoading,
  interCompanyFlag,
  landingPageFlag,
  handleDeclineButtonClick,
  handleReviewButtonClick,
  handleReviewAndPrintButton,
  handlePrintCheckButtonClick,
  isDeclinePaymentLoading
}) => {
  const departmentName = useClient()?.headers['x-department-name'];
  switch (activeAuthorizePage) {
    case ActiveAuthorizePaymentPage.AuthorizeReview:
      return <AuthorizePaymentPage />;
    case ActiveAuthorizePaymentPage.AuthorizeResult:
      return <VendorPaymentResultPage />;
    case ActiveAuthorizePaymentPage.ReviewChecks:
      return interCompanyFlag ? <ReviewChecksPage /> : <></>;
    default:
      return (
        <LandingPageContainer $isMFE={client?.isMFE}>
          <LandingPageHeader />
          <StyledPageContentHeader>
            <StoreSelect />
            {isLoading ||
            (selectedTab === Tabs.PrintChecks && isFetchingPrintChecks) ? (
              <SkeletonHeader type={selectedTab} />
            ) : (
              <>
                {(selectedTab === Tabs.ToBePaid ||
                  selectedTab === Tabs.NeedsAuthorization) && (
                  <VendorsReviewSelection
                    handleDeclineButtonClick={handleDeclineButtonClick}
                    handleReviewButtonClick={handleReviewButtonClick}
                    isLoading={isDeclinePaymentLoading}
                  />
                )}
                {selectedTab === Tabs.PrintChecks &&
                  (interCompanyFlag ? (
                    <PrintChecksPageHeader
                      handleReviewAndPrintButton={handleReviewAndPrintButton}
                    />
                  ) : (
                    <PrintChecksHeader
                      handlePrintCheckButtonClick={handlePrintCheckButtonClick}
                    />
                  ))}
                {selectedTab === Tabs.ReconcileCreditCards && (
                  <ReconciliationHeader />
                )}
              </>
            )}
          </StyledPageContentHeader>
          {departmentName ? (
            <>
              {landingPageFlag === true ? (
                <LandingPageTable />
              ) : (
                <VendorsTablePage />
              )}
            </>
          ) : null}
        </LandingPageContainer>
      );
  }
};

export default AuthorizeScreenFlow;
